import React from "react";
import { observer } from "mobx-react-lite";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { getUrl } = Util;
import { Drawer } from "antd";
import cx from "classnames";
import XtSvg from "@/components/Xt/Svg";
import IconDeposit from "@/components/Pages/Trade/_cmpt/modalTriggerBtn/add/icon/deposit";
import IconBuy from "@/components/Pages/Trade/_cmpt/modalTriggerBtn/add/icon/buy";
import styles from "./index.module.scss";

interface DepositDrawerProps {
  open: boolean;
  onClose: () => void;
  currency?: string;
}

const DepositDrawer: React.FC<DepositDrawerProps> = ({ open, onClose }) => {
  const t = useTranslation();

  // 加密货币充值仅支持 USDT，固定跳转 usdt
  const currency = "usdt";

  return (
    <Drawer
      placement="bottom"
      closable={false}
      open={open}
      onClose={onClose}
      className={styles.depositDrawer}
      destroyOnClose={true}
      title={<span className={styles.headerTitle}>{t("cfd.marginDeposit")}</span>}
      extra={
        <button className={cx("btnTxt", "btnHover")} onClick={onClose}>
          <XtSvg icon="close" />
        </button>
      }
    >
      <div className={styles.depositDrawerContent}>
        <a 
          href={getUrl("/wallet/account/common/deposit?currency=" + currency)}
          className={styles.depositOption}
          onClick={onClose}
        >
          <div className={styles.depositIcon}>
            <IconDeposit />
          </div>
          <div className={styles.depositText}>
            <p>{t("trade.deposit")}</p>
          </div>
        </a>
        <a 
          href={getUrl("/otc/index")}
          className={styles.depositOption}
          onClick={onClose}
        >
          <div className={styles.depositIcon}>
            <IconBuy />
          </div>
          <div className={styles.depositText}>
            <p>{t("trade.buyOtc")}</p>
          </div>
        </a>
      </div>
    </Drawer>
  );
};

export default observer(DepositDrawer);
